import { createContext, useContext, type ReactNode } from 'react';

/**
 * Admin read-only mode (C-024). An administrator without the super_user role may see the scoring
 * configuration (Modules & weights, CRQC curve, Policies, Cryptography KB, Threat Catalog) but not
 * change it: edit, import, add and delete controls render nothing under this context.
 * The backend read routes allow admin; who may write is decided by the backend, not by this flag.
 */
const AdminReadOnlyContext = createContext(false);

export function useAdminReadOnly(): boolean {
  return useContext(AdminReadOnlyContext);
}

export function AdminReadOnly({ readOnly, children }: { readOnly: boolean; children: ReactNode }) {
  return (
    <AdminReadOnlyContext.Provider value={readOnly}>
      {readOnly && (
        <div className="mb-4 border border-ink-200 bg-ink-50 rounded-sm px-3 py-2 text-xs text-ink-700" data-testid="admin-read-only">
          Read-only. You can see this configuration because it drives every score; only a super user can change it.
        </div>
      )}
      {children}
    </AdminReadOnlyContext.Provider>
  );
}
